import {execute} from "../../apiCommandsExecutor";

import {
    GetBookingMenuRequest,
    GetBookingMenuResponse,
    GetBookingMenusRequest,
    GetBookingMenusResponse,
    ICreateBookingMenuRequest,
    ICreateBookingMenuResponse,
    ICreateExternalMenuIntegrationRequest,
    ICreateExternalMenuIntegrationResponse,
    ICreateMenuCategoryRequest,
    ICreateMenuCategoryResponse,
    ICreateMenuItemModifierSetRequest,
    ICreateMenuItemModifierSetResponse,
    ICreateMenuItemRequest,
    ICreateMenuItemResponse,
    ICreateMenuRequest,
    ICreateMenuResponse,
    IDeleteMenuCategoryRequest,
    IDeleteMenuCategoryResponse,
    IDeleteMenuItemModifierSetRequest,
    IDeleteMenuItemModifierSetResponse,
    IDeleteMenuItemRequest,
    IDeleteMenuItemResponse,
    IGetExternalMenuItemsRequest,
    IGetExternalMenuItemsResponse,
    IGetMenuItemModifierSetsRequest,
    IGetMenuItemModifierSetsResponse,
    IGetMenuRequest,
    IGetMenuResponse,
    IGetMenusRequest,
    IGetMenusResponse,
    IMenusGetTelegramReportingBindingUrlRequest,
    IMenusGetTelegramReportingBindingUrlResponse,
    IUpdateMenuCategoryRequest,
    IUpdateMenuCategoryResponse,
    IUpdateMenuItemExternalIdRequest,
    IUpdateMenuItemExternalIdResponse,
    IUpdateMenuItemModifierSetRequest,
    IUpdateMenuItemModifierSetResponse,
    IUpdateMenuItemRequest,
    IUpdateMenuItemResponse,
    IUpdateMenuRequest,
    IUpdateMenuResponse,
    IDeleteMenuBookingItemRequest,
    IDeleteMenuBookingItemResponse,
    IUpdateMenuBookingItemRequest,
    IUpdateMenuBookingItemResponse,
    TranslationServiceTranslateTextRequest,
    TranslationServiceTranslateTextResponse,
    UpdateBookingMenuRequest,
    UpdateBookingMenuResponse,
    IUpdateMenuBookingCategoryRequest,
    IUpdateMenuBookingCategoryResponse,
    ICreateMenuBookingItemResponse,
    ICreateMenuBookingItemRequest,
    ICreateMenuBookingCategoryRequest,
    ICreateMenuBookingCategoryResponse,
    IDeleteMenuRequest,
    IDeleteMenuResponse,
    DeleteBookingMenuRequest,
    DeleteBookingMenuResponse,
    IDeleteMenuBookingCategoryRequest,
    IDeleteMenuBookingCategoryResponse,
    IUpdateMenuItemModifierSetExternalSettingsRequest, IUpdateMenuItemModifierSetExternalSettingsResponse
} from "./requestsResponses";
import {MenuApiMethods} from "./methods";
import {ExecutionStatus} from "../general/requestsResponses";

export const getMenus = async () => {
    const res = await execute<IGetMenusRequest, IGetMenusResponse>(
        MenuApiMethods.getMenus,
        {});
    return res.data;
};

export const getBookingMenus = async () => {
    const res = await execute<GetBookingMenusRequest, GetBookingMenusResponse>(
        MenuApiMethods.bookingMenusGetBookingMenus,
        {});
    return res.data;
};

export const createMenu = async (params: ICreateMenuRequest) => {
    const res = await execute<ICreateMenuRequest, ICreateMenuResponse>(
        MenuApiMethods.createMenu,
        params
    );
    return {
        err: res.data.executionStatus !== ExecutionStatus.Finished,
        menuId: res.data.menuId
    }
};

export const createBookingMenu = async (params: ICreateBookingMenuRequest) => {
    const res = await execute<ICreateBookingMenuRequest, ICreateBookingMenuResponse>(
        MenuApiMethods.bookingMenusCreateBookingMenu,
        params
    );
    return {
        err: res.data.executionStatus !== ExecutionStatus.Finished,
        menuId: res.data.menuId
    }
};

export const updateMenu = async (params: IUpdateMenuRequest) => {
    const res = await execute<IUpdateMenuRequest, IUpdateMenuResponse>(
        MenuApiMethods.updateMenu,
        params
    );
    return {
        err: res.data.executionStatus !== ExecutionStatus.Finished,
    }
};

export const updateBookingMenu = async (params: UpdateBookingMenuRequest) => {
    const res = await execute<UpdateBookingMenuRequest, UpdateBookingMenuResponse>(
        MenuApiMethods.bookingMenusUpdateBookingMenu,
        params
    );
    return {
        err: res.data.executionStatus !== ExecutionStatus.Finished,
    }
};


export const createCategory = async (params: ICreateMenuCategoryRequest) => {
    const res = await execute<ICreateMenuCategoryRequest, ICreateMenuCategoryResponse>(
        MenuApiMethods.createMenuCategory,
        params
    );
    return res.data;
};

export const createBookingCategory = async (params: ICreateMenuBookingCategoryRequest) => {
    const res = await execute<ICreateMenuBookingCategoryRequest, ICreateMenuBookingCategoryResponse>(
        MenuApiMethods.menuBookingCategoriesCreateMenuBookingCategory,
        params
    );
    return res.data;
};

export const updateCategory = async (params: IUpdateMenuCategoryRequest) => {
    const res = await execute<IUpdateMenuCategoryRequest, IUpdateMenuCategoryResponse>(
        MenuApiMethods.updateMenuCategory,
        params
    );
    return res.data;
};

export const updateBookingCategory = async (params: IUpdateMenuBookingCategoryRequest) => {
    const res = await execute<IUpdateMenuBookingCategoryRequest, IUpdateMenuBookingCategoryResponse>(
        MenuApiMethods.menuBookingCategoriesUpdateMenuBookingCategory,
        params
    );
    return res.data;
};

export const deleteCategory = async (params: IDeleteMenuCategoryRequest) => {
    const res = await execute<IDeleteMenuCategoryRequest, IDeleteMenuCategoryResponse>(
        MenuApiMethods.deleteMenuCategory,
        params
    );
    return res.data;
};

export const deleteBookingCategory = async (params: IDeleteMenuBookingCategoryRequest) => {
    const res = await execute<IDeleteMenuBookingCategoryRequest, IDeleteMenuBookingCategoryResponse>(
        MenuApiMethods.menuBookingCategoriesDeleteMenuBookingCategory,
        params
    );
    return res.data;
};


export const getMenuById = async (params: IGetMenuRequest ) => {
    const res = await execute<IGetMenuRequest, IGetMenuResponse>(
        MenuApiMethods.getMenu,
        params
    );
    return res.data;
};

export const getBookingMenuById = async (params: GetBookingMenuRequest) => {
    const res = await execute<GetBookingMenuRequest, GetBookingMenuResponse>(
        MenuApiMethods.bookingMenusGetBookingMenu,
        params
    );
    return res.data;
};


export const createMenuItem = async (params: ICreateMenuItemRequest) => {
    const res = await execute<ICreateMenuItemRequest, ICreateMenuItemResponse>(
        MenuApiMethods.createMenuItem,
        params
    );
    return res.data;
};

export const createMenuBookingItem = async (params: ICreateMenuBookingItemRequest) => {
    const res = await execute<ICreateMenuBookingItemRequest, ICreateMenuBookingItemResponse>(
        MenuApiMethods.menuBookingItemsCreateMenuBookingItem,
        params
    );
    return res.data;
};

export const updateMenuItem = async (params: IUpdateMenuItemRequest) => {
    const res = await execute<IUpdateMenuItemRequest, IUpdateMenuItemResponse>(
        MenuApiMethods.updateMenuItem,
        params
    );
    return res.data;
};

export const updateMenuBookingItem = async (params: IUpdateMenuBookingItemRequest) => {
    const res = await execute<IUpdateMenuBookingItemRequest, IUpdateMenuBookingItemResponse>(
        MenuApiMethods.menuBookingItemsUpdateMenuBookingItem,
        params
    );
    return res.data;
};

export const deleteMenuItem = async (params: IDeleteMenuItemRequest) => {
    const res = await execute<IDeleteMenuItemRequest, IDeleteMenuItemResponse>(
        MenuApiMethods.deleteMenuItem,
        params
    );
    return res.data;
}

export const deleteMenuBookingItem = async (params: IDeleteMenuBookingItemRequest) => {
    const res = await execute<IDeleteMenuBookingItemRequest, IDeleteMenuBookingItemResponse>(
        MenuApiMethods.menuBookingItemsDeleteMenuBookingItem,
        params
    );
    return res.data;
}


export const getModifiersSet = async () => {
    const res = await execute<IGetMenuItemModifierSetsRequest, IGetMenuItemModifierSetsResponse>(
        MenuApiMethods.getMenuItemModifierSets,
        {});
    return res.data;
};



export const createModifiersSet = async (params: ICreateMenuItemModifierSetRequest) => {
    const res = await execute<ICreateMenuItemModifierSetRequest, ICreateMenuItemModifierSetResponse>(
        MenuApiMethods.createMenuItemModifierSet,
        params
    );
    return res.data;
};

export const updateModifiersSet = async (params: IUpdateMenuItemModifierSetRequest) => {
    const res = await execute<IUpdateMenuItemModifierSetRequest, IUpdateMenuItemModifierSetResponse>(
        MenuApiMethods.updateMenuItemModifierSet,
        params
    );
    return res.data;
};


export const updateModifiersSetExternalSettings = async (params: IUpdateMenuItemModifierSetExternalSettingsRequest) => {
    const res = await execute<IUpdateMenuItemModifierSetExternalSettingsRequest, IUpdateMenuItemModifierSetExternalSettingsResponse>(
        MenuApiMethods.updateMenuItemModifierSetExternalSettings,
        params
    );
    return res.data;
};

export const deleteModifiersSet = async (params: IDeleteMenuItemModifierSetRequest) => {
    const res = await execute<IDeleteMenuItemModifierSetRequest, IDeleteMenuItemModifierSetResponse>(
        MenuApiMethods.deleteMenuItemModifierSet,
        params
    );
    return res.data;
}

export const getTelegramReportingBindingUrl = async (params: IMenusGetTelegramReportingBindingUrlRequest) => {
    const res = await execute<IMenusGetTelegramReportingBindingUrlRequest, IMenusGetTelegramReportingBindingUrlResponse>(
        MenuApiMethods.getTelegramReportingBindingUrl,
        params);
    return res.data;
};


export const createMenuIntegration = async (params: ICreateExternalMenuIntegrationRequest) => {
    const res = await execute<ICreateExternalMenuIntegrationRequest, ICreateExternalMenuIntegrationResponse>(
        MenuApiMethods.createExternalMenuIntegration,
        params
    );
    return res.data;
};



export const updateMenuItemExternalId = async (params: IUpdateMenuItemExternalIdRequest) => {
    const res = await execute<IUpdateMenuItemExternalIdRequest, IUpdateMenuItemExternalIdResponse>(
        MenuApiMethods.updateMenuItemExternalId,
        params
    );
    return res.data;
}



export const getExternalMenuItems = async (params: IGetExternalMenuItemsRequest) => {
    const res = await execute<IGetExternalMenuItemsRequest, IGetExternalMenuItemsResponse>(
        MenuApiMethods.getExternalMenuItems,
        params
    );
    return res.data;
}

export const getTranslate = async (data: TranslationServiceTranslateTextRequest) => {
    const res = await execute<TranslationServiceTranslateTextRequest, TranslationServiceTranslateTextResponse>(MenuApiMethods.translateServiceTranslateText,
        data);
    return res;
};

